import { render, staticRenderFns } from "./AccountButton.vue?vue&type=template&id=7352fa20&scoped=true&"
import script from "./AccountButton.vue?vue&type=script&lang=js&"
export * from "./AccountButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7352fa20",
  null
  
)

export default component.exports